import store from "@/redux/store";

import React, { useState } from "react";
import { useParams } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";
import { Overview } from "@/views/team/Overview";
import { loadUsers } from '@/reducers/User'
import { show } from '@/reducers/Modal'
import Wide from "@/views/base/drawer/Wide";
import { DetailPopup as CustomerDetailPopup } from "@/views/customer/DetailPopup";
import { DetailPopup as FileDetailPopup } from "@/views/files/DetailPopup";

class DrawerController extends React.Component {
  constructor(props) {
    super(props);
    this.hasCloseEventHandler = null;
    
    //if(!getEventListeners(document)) {
    //}
    this.state = { data: 0 };
    
  }
   componentDidMount() {
       
    }
   componentWillUnMount() {
       
    }
   componentUnMount() {
       
    }
/*    
    shouldComponentUpdate(nextProps, nextState){
        console.log("test",nextProps)
        console.log("test",nextState)
    }
*/  
  onCloseEvent =(event) => {
      
      if(this.props.onCloseHandler) {
          this.props.onCloseHandler(event);
      }
  }

  
  render() {
//      const {data} = this.state;
      const {children} = this.props;
      let viewToShow = (<></>);
      if(this.props.data) {
            const {click} = this.props.data;
            const {selected, data} = this.props;
            var childtoShow = (<></>);
            var headerFor = "";
        if(this.props.type == "customer") {
            childtoShow = (<CustomerDetailPopup key={click} data={selected} />)
            headerFor = data?.name;
        } else if(this.props.type == "user") {
            headerFor = data.first_name+" "+data.preposition+" "+data.last_name;
        } else if(this.props.type == "file") {
            headerFor = data.file.name;
            childtoShow = (<FileDetailPopup key={click} data={data} />)
            }             
          viewToShow = (<Wide data={data} key={data?.key} headerTxt={headerFor} onCloseHandler={this.onCloseEvent} onKeyUp={this.onKeyUpHandler}>
            {childtoShow}
            {children && 
                children
            }
          </Wide>);
      } else {
          
      }
      return (
          viewToShow
      );
      
  }
}
const DrawerControllerInit = (props) => {
  return (
    <DrawerController
      {...props}
    />
  );
};

function mapStateToProps(state) {
    const {CustomerReducer} = state;
    const {selected} = CustomerReducer;
  return {
        selected: selected

  };
}

export default connect(mapStateToProps)(DrawerControllerInit);  